import { a as m } from "./chunk-5LTMIXMU.mjs";
import { b as e } from "./chunk-LSZKOVGW.mjs";
import { j as o, k as r } from "./chunk-GTEBSQTL.mjs";
var i = new o({
  locale: [m, e, r]
});
export { i as a };